"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var Lockr = __importStar(require("lockr"));
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var AcceptPolicy_1 = require("./AcceptPolicy");
var Fields_1 = __importDefault(require("./Fields"));
var useInitialValues_1 = require("./useInitialValues");
var SignUp = function (_a) {
    var _b = _a.welcomeFields, welcomeFields = _b === void 0 ? ['email', 'password', 'country', 'currency'] : _b;
    var lang = (0, next_intl_1.useLocale)();
    var validateSchema = (0, apps_shared_1.useSignUpValidateSchema)(welcomeFields);
    var initialValues = (0, useInitialValues_1.useInitialValues)();
    var tError = (0, next_intl_1.useTranslations)('errors');
    var params = (0, navigation_1.useSearchParams)();
    var code = params.get('code') || undefined;
    var closeModal = (0, apps_shared_1.useCloseModal)();
    var openModal = (0, apps_shared_1.useOpenModal)();
    var _c = (0, swr_hooks_1.useSignUp)({
        successAction: function () {
            closeModal();
            openModal(apps_shared_1.POPUP_CONSTANTS.DEPOSIT);
        },
    }), signUp = _c.signUp, isSubmitting = _c.isSubmitting, error = _c.error;
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var affiliateData = Lockr.get('affiliate');
        var inviteData = Lockr.get('invite');
        var newDate = (affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.date)
            ? (0, date_fns_1.addDays)(new Date(affiliateData.date), 7)
            : new Date();
        var isExpiredAffDate = (0, date_fns_1.isAfter)(new Date(), newDate);
        signUp({
            receivePromos: true,
            email: values === null || values === void 0 ? void 0 : values.email,
            nickname: values === null || values === void 0 ? void 0 : values.nickname,
            password: values === null || values === void 0 ? void 0 : values.password,
            currency: (_a = values === null || values === void 0 ? void 0 : values.currency) === null || _a === void 0 ? void 0 : _a.value,
            country: (_b = values === null || values === void 0 ? void 0 : values.country) === null || _b === void 0 ? void 0 : _b.value,
            partnerId: !isExpiredAffDate && ((_c = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _c === void 0 ? void 0 : _c.partnerId)
                ? Number((_d = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _d === void 0 ? void 0 : _d.partnerId)
                : undefined,
            offerId: !isExpiredAffDate && ((_e = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _e === void 0 ? void 0 : _e.offerId)
                ? Number((_f = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _f === void 0 ? void 0 : _f.offerId)
                : undefined,
            clickId: !isExpiredAffDate && ((_g = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _g === void 0 ? void 0 : _g.clickId)
                ? String((_h = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _h === void 0 ? void 0 : _h.clickId)
                : undefined,
            partnerType: !isExpiredAffDate && ((_j = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _j === void 0 ? void 0 : _j.type)
                ? String((_k = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _k === void 0 ? void 0 : _k.type)
                : undefined,
            referralCode: (inviteData === null || inviteData === void 0 ? void 0 : inviteData.invite)
                ? String(inviteData === null || inviteData === void 0 ? void 0 : inviteData.invite)
                : undefined,
            language: lang ? lang : undefined,
            code: code,
        });
    }, [lang, signUp, code]);
    return (react_1.default.createElement("div", { className: "swiper-no-swiping" },
        react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmitHandler, validate: (0, apps_shared_1.formValidator)(validateSchema), initialValues: initialValues, render: function (_a) {
                var handleSubmit = _a.handleSubmit;
                return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Fields_1.default, { welcomeFields: welcomeFields, isSubmitting: isSubmitting })),
                    react_1.default.createElement(AcceptPolicy_1.AcceptPolicy, null),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.errorWrapper }, error && react_1.default.createElement(ui_components_1.ErrorText, null, tError(error)))));
            } })));
};
exports.default = SignUp;
